import { render } from "./RemoveWatermark.vue?vue&type=template&id=6c45a4e7&scoped=true"
import script from "./RemoveWatermark.vue?vue&type=script&lang=js"
export * from "./RemoveWatermark.vue?vue&type=script&lang=js"

import "./RemoveWatermark.vue?vue&type=style&index=0&id=6c45a4e7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c45a4e7"]])

export default __exports__